import React from 'react';

const CriteriaForm = ({
    formData,
    errors,
    isProcessing,
    onInputChange
}) => {
    return (
        <div className="space-y-6 mb-8">
            {/* Required Skills */}
            <div className="relative">
                <input
                    type="text"
                    placeholder="Required Skills (comma separated: SQL, SSIS, Python...)"
                    value={formData.requiredSkills}
                    onChange={(e) => onInputChange('requiredSkills', e.target.value)}
                    className={`w-full p-4 border-2 rounded-xl text-lg outline-none transition-all ${
                        errors.requiredSkills 
                            ? 'border-red-300 focus:border-red-500' 
                            : 'border-gray-200 focus:border-gray-400'
                    }`}
                    disabled={isProcessing}
                />
                {errors.requiredSkills && (
                    <div className="text-red-500 text-sm mt-1 text-left">
                        {errors.requiredSkills}
                    </div>
                )}
            </div>

            {/* Experience and Job Title */}
            <div className="grid grid-cols-2 gap-6">
                <div className="relative">
                    <input
                        type="text"
                        placeholder="Experience (e.g., 2-3 years, 5+ years)"
                        value={formData.experience}
                        onChange={(e) => onInputChange('experience', e.target.value)}
                        className={`w-full p-4 border-2 rounded-xl text-lg outline-none transition-all ${
                            errors.experience 
                                ? 'border-red-300 focus:border-red-500' 
                                : 'border-gray-200 focus:border-gray-400'
                        }`}
                        disabled={isProcessing}
                    />
                    {errors.experience && (
                        <div className="text-red-500 text-sm mt-1 text-left">
                            {errors.experience}
                        </div>
                    )}
                </div>

                <div className="relative">
                    <input
                        type="text"
                        placeholder="Enter Job Title"
                        value={formData.jobTitle}
                        onChange={(e) => onInputChange('jobTitle', e.target.value)}
                        className={`w-full p-4 border-2 rounded-xl text-lg outline-none transition-all ${
                            errors.jobTitle 
                                ? 'border-red-300 focus:border-red-500' 
                                : 'border-gray-200 focus:border-gray-400'
                        }`}
                        disabled={isProcessing}
                    />
                    {errors.jobTitle && (
                        <div className="text-red-500 text-sm mt-1 text-left">
                            {errors.jobTitle}
                        </div>
                    )}
                </div>
            </div>

            {/* NEW: Exclusion Criteria */}
            <div className="relative">
                <input
                    type="text"
                    placeholder="Exclude Keywords (Optional - comma separated: O9 Solutions, Oracle EBS...)"
                    value={formData.exclusionCriteria || ''}
                    onChange={(e) => onInputChange('exclusionCriteria', e.target.value)}
                    className={`w-full p-4 border-2 rounded-xl text-lg outline-none transition-all ${
                        errors.exclusionCriteria 
                            ? 'border-red-300 focus:border-red-500' 
                            : 'border-gray-200 focus:border-gray-400'
                    }`}
                    disabled={isProcessing}
                />
                <div className="flex justify-between items-center mt-2">
                    {formData.exclusionCriteria && formData.exclusionCriteria.length > 0 && (
                        <div className="text-sm text-orange-600 font-medium">
                            {formData.exclusionCriteria.split(',').length} exclusion(s)
                        </div>
                    )}
                </div>
                {errors.exclusionCriteria && (
                    <div className="text-red-500 text-sm mt-1 text-left">
                        {errors.exclusionCriteria}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CriteriaForm;